import { EventEmitter } from '@angular/core';
var ComponentTab = (function () {
    function ComponentTab() {
        this.onTabIndex = new EventEmitter();
    }
    ComponentTab.prototype.ngOnInit = function () {
    };
    ComponentTab.prototype.ngAfterViewInit = function () {
        if (this.tabNum == 0) {
            $("#slide").addClass("left");
        }
        else if (this.tabNum == 1) {
            $("#slide").addClass("right");
        }
    };
    ComponentTab.prototype.tab = function (i) {
        this.onTabIndex.emit(i);
        this.tabNum = i;
        $("#slide").removeClass("left");
        $("#slide").removeClass("right");
        if (i === 0) {
            $("#slide").addClass("slide0");
            $("#slide").removeClass("slide1");
        }
        else if (i === 1) {
            $("#slide").addClass("slide1");
            $("#slide").removeClass("slide0");
        }
    };
    return ComponentTab;
}());
export { ComponentTab };



// WEBPACK FOOTER //
// ./src/component/tab/component.tab.ts.pre-build-optimizer.js